module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [(!_vm.mainTarget || !_vm.mainType) ? _c('div', {
    staticClass: "flex-row content-box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("安装人")]), _vm._v(" "), _c('div', {
    staticClass: "input-box flex-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fitMan),
      expression: "fitMan"
    }],
    attrs: {
      "type": "",
      "maxlength": "11",
      "name": ""
    },
    domProps: {
      "value": (_vm.fitMan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fitMan = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.mainTarget || !_vm.mainType) ? _c('div', {
    staticClass: "flex-row content-box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("安装电话")]), _vm._v(" "), _c('div', {
    staticClass: "input-box flex-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fitMobile),
      expression: "fitMobile"
    }],
    attrs: {
      "type": "",
      "maxlength": "11",
      "name": ""
    },
    domProps: {
      "value": (_vm.fitMobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.changePhone($event, 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fitMobile = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.questionLists), function(item, index) {
    return _c('div', {
      staticClass: "question-item"
    }, [(item.queType == 3) ? _c('div', {
      staticClass: "flex-row content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box flex-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers && _vm.answers[index] && _vm.answers[index].optText),
        expression: "answers && answers[index] && answers[index].optText"
      }],
      attrs: {
        "type": "",
        "name": ""
      },
      domProps: {
        "value": (_vm.answers && _vm.answers[index] && _vm.answers[index].optText)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers && _vm.answers[index] && _vm.answers[index], "optText", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (item.queType == 5) ? _c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers && _vm.answers[index] && _vm.answers[index].optText),
        expression: "answers && answers[index] && answers[index].optText"
      }],
      domProps: {
        "value": (_vm.answers && _vm.answers[index] && _vm.answers[index].optText)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers && _vm.answers[index] && _vm.answers[index], "optText", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (item.queType == 2) ? _c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box"
    }, _vm._l((item.options), function(option) {
      return _c('label', {
        key: option.optId,
        staticClass: "check-box"
      }, [_c('input', {
        staticClass: "optInput",
        attrs: {
          "type": "checkbox",
          "name": index
        },
        on: {
          "change": function($event) {
            return _vm.change($event, index, option.optId)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "optLabel"
      }, [_vm._v(_vm._s(option.optDesc))]), _vm._v(" "), (option.optImagePath) ? _c('img', {
        staticClass: "optImg",
        attrs: {
          "src": _vm.imgUrl + '/' + option.optImagePath
        }
      }) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (item.queType == 1) ? _c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box"
    }, _vm._l((item.options), function(option) {
      return _c('label', {
        key: option.optId,
        staticClass: "check-box"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.answers && _vm.answers[index] && _vm.answers[index].optId),
          expression: "answers && answers[index] && answers[index].optId"
        }],
        staticClass: "optInput",
        attrs: {
          "type": "radio",
          "name": index
        },
        domProps: {
          "value": option.optId,
          "checked": _vm._q(_vm.answers && _vm.answers[index] && _vm.answers[index].optId, option.optId)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.answers && _vm.answers[index] && _vm.answers[index], "optId", option.optId)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "optLabel"
      }, [_vm._v(_vm._s(option.optDesc))]), _vm._v(" "), (option.optImagePath) ? _c('img', {
        staticClass: "optImg",
        attrs: {
          "src": _vm.imgUrl + '/' + option.optImagePath
        }
      }) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (item.queType == 4) ? _c('div', {
      staticClass: "img-box content-box"
    }, [_c('div', {
      staticClass: "flex-row"
    }, [_c('label', {
      staticClass: "flex-item"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img-item add"
    }, [_vm._v("\n            添加照片\n            "), _c('input', {
      ref: "img1",
      refInFor: true,
      staticClass: "file-button",
      attrs: {
        "type": "file",
        "multiple": "",
        "accept": "image/gif,image/jpeg,image/jpg,image/png",
        "value": ""
      },
      on: {
        "change": function($event) {
          return _vm.canvasSelImg($event, index)
        }
      }
    })])]), _vm._v(" "), _vm._l((_vm.getAttachs(index)), function(item) {
      return _c('div', {
        staticClass: "image-list"
      }, [_c('div', {
        staticClass: "verticalM image-box"
      }, [_c('img', {
        staticClass: "verticalM-box",
        attrs: {
          "src": item.fileUrl
        }
      })]), _vm._v(" "), _c('label', {
        staticClass: "delete",
        on: {
          "click": function($event) {
            return _vm.deleteImg(item.attach_Id, index)
          }
        }
      })])
    })], 2) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.mainTarget && _vm.mainType) ? _c('div', {
    staticClass: "flex-item btn",
    on: {
      "click": _vm.initPriceMainFn
    }
  }, [_vm._v("\n      去商城\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-item btn submitBtn",
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v("提交")])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "登录",
      "dialogClass": "authCodeDialog"
    }
  }, [_c('div', {
    staticClass: "flex-row auth-info"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("图片验证码")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.randomCode),
      expression: "randomCode"
    }],
    attrs: {
      "maxlength": "4",
      "type": "",
      "name": "randomCode"
    },
    domProps: {
      "value": (_vm.randomCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.randomCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBtn",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('span', {
    staticClass: "img-code-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.randomCodePath
    },
    on: {
      "click": _vm.refreshImgCode
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row auth-info"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "maxlength": "11",
      "type": "",
      "name": "",
      "readonly": _vm.isReadonly
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.changePhone($event, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBtn",
    class: {
      disabled: _vm.isDisabled
    },
    on: {
      "click": _vm.getAuthCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.codeTitle) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row auth-info"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authCode),
      expression: "authCode"
    }],
    attrs: {
      "type": "",
      "name": "",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.authCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row buttons"
  }, [_c('a', {
    staticClass: "flex-item button",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("去商城")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item button loginBtn",
    on: {
      "click": _vm.loginCode
    }
  }, [_vm._v("登录")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6c80c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/questions/index.vue
// module id = 397
// module chunks = 68